/**
 * @generated SignedSource<<0dbc1398b3c3b48392fa549c21515b93>>
 * @relayHash 32c8fd5ae1b6ab7501ae90c842ccdd27
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ba375f21ba1853671ceaf7b3ac51292c7ecd755be5a458810becb1128b5e825b

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PTGraphQLPageStatus = "CURRENT" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type FolderOverviewFirstPageQuery$variables = {
  after?: string | null;
  contentId: string;
  id: string;
  includeAutomationDiscovery?: boolean | null;
  includeDevDocsSyncStatus?: boolean | null;
};
export type FolderOverviewFirstPageQuery$data = {
  readonly folderViewActions?: {
    readonly " $fragmentSpreads": FragmentRefs<"FolderViewActions_query">;
  } | null;
  readonly ptpage: {
    readonly children: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly links: {
          readonly webui: string | null;
        } | null;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly key: string | null;
            readonly value: string | null;
            readonly version: {
              readonly number: number | null;
            } | null;
          } | null> | null;
        } | null;
        readonly status: PTGraphQLPageStatus | null;
        readonly subType: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null> | null;
      readonly pageInfo: {
        readonly endCursor: string | null;
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly id: string;
    readonly subType: string | null;
    readonly title: string | null;
    readonly type: string | null;
  } | null;
  readonly singleContent: {
    readonly contentProperties: {
      readonly latest: {
        readonly coverPicture: string | null;
      } | null;
    } | null;
    readonly devDocsOwnershipProperties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
      } | null> | null;
    } | null;
    readonly devDocsProperties?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null;
    } | null> | null;
    readonly properties: {
      readonly nodes: ReadonlyArray<{
        readonly id: string | null;
        readonly key: string | null;
        readonly value: string | null;
      } | null> | null;
    } | null;
  } | null;
};
export type FolderOverviewFirstPageQuery = {
  response: FolderOverviewFirstPageQuery$data;
  variables: FolderOverviewFirstPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeAutomationDiscovery"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeDevDocsSyncStatus"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "title"
},
v7 = {
  "kind": "ScalarField",
  "name": "type"
},
v8 = {
  "kind": "ScalarField",
  "name": "subType"
},
v9 = {
  "kind": "ScalarField",
  "name": "key"
},
v10 = {
  "kind": "ScalarField",
  "name": "value"
},
v11 = {
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    },
    {
      "kind": "Literal",
      "name": "status",
      "value": [
        "CURRENT",
        "DRAFT"
      ]
    }
  ],
  "concreteType": "PTPage",
  "kind": "LinkedField",
  "name": "ptpage",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    {
      "args": [
        {
          "kind": "Variable",
          "name": "after",
          "variableName": "after"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 40
        }
      ],
      "concreteType": "PTPaginatedPageList",
      "kind": "LinkedField",
      "name": "children",
      "plural": false,
      "selections": [
        {
          "concreteType": "PTPage",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v5/*: any*/),
            (v6/*: any*/),
            {
              "kind": "ScalarField",
              "name": "status"
            },
            (v7/*: any*/),
            (v8/*: any*/),
            {
              "concreteType": "Map_LinkType_String",
              "kind": "LinkedField",
              "name": "links",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "webui"
                }
              ]
            },
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "keys",
                  "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor"
                  ]
                }
              ],
              "concreteType": "PaginatedJsonContentPropertyList",
              "kind": "LinkedField",
              "name": "properties",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JsonContentProperty",
                  "kind": "LinkedField",
                  "name": "nodes",
                  "plural": true,
                  "selections": [
                    (v5/*: any*/),
                    (v9/*: any*/),
                    (v10/*: any*/),
                    {
                      "concreteType": "Version",
                      "kind": "LinkedField",
                      "name": "version",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "number"
                        }
                      ]
                    }
                  ]
                }
              ],
              "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
            }
          ]
        },
        {
          "concreteType": "PTPageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "hasNextPage"
            },
            {
              "kind": "ScalarField",
              "name": "endCursor"
            }
          ]
        }
      ]
    }
  ]
},
v12 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v13 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    }
  ]
},
v14 = {
  "concreteType": "ContentProperties",
  "kind": "LinkedField",
  "name": "contentProperties",
  "plural": false,
  "selections": [
    {
      "concreteType": "PublishedContentProperties",
      "kind": "LinkedField",
      "name": "latest",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "coverPicture"
        }
      ]
    }
  ]
},
v15 = [
  {
    "concreteType": "JsonContentProperty",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v5/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ]
  }
],
v16 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "smartFolderProperties"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": "properties(keys:[\"smartFolderProperties\"])"
},
v17 = [
  {
    "kind": "Literal",
    "name": "keys",
    "value": [
      "devdocsProperties"
    ]
  }
],
v18 = {
  "alias": "devDocsOwnershipProperties",
  "args": (v17/*: any*/),
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        (v9/*: any*/)
      ]
    }
  ],
  "storageKey": "properties(keys:[\"devdocsProperties\"])"
},
v19 = {
  "condition": "includeDevDocsSyncStatus",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "devDocsProperties",
      "args": (v17/*: any*/),
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": (v15/*: any*/),
      "storageKey": "properties(keys:[\"devdocsProperties\"])"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "FolderOverviewFirstPageQuery",
    "selections": [
      {
        "condition": "includeAutomationDiscovery",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "contentId",
                      "variableName": "contentId"
                    }
                  ],
                  "kind": "FragmentSpread",
                  "name": "FolderViewActions_query"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "folderViewActions"
          }
        ]
      },
      (v11/*: any*/),
      {
        "args": (v12/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v14/*: any*/),
          (v16/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "FolderOverviewFirstPageQuery",
    "selections": [
      (v11/*: any*/),
      {
        "args": (v12/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v14/*: any*/),
          (v16/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v5/*: any*/)
        ]
      },
      {
        "condition": "includeAutomationDiscovery",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "user",
            "args": [
              {
                "kind": "Literal",
                "name": "current",
                "value": true
              }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
              {
                "concreteType": "AtlassianUserEmail",
                "kind": "LinkedField",
                "name": "emails",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "isPrimary"
                  }
                ]
              },
              (v5/*: any*/)
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
          },
          {
            "args": (v12/*: any*/),
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "32c8fd5ae1b6ab7501ae90c842ccdd27",
    "id": "ba375f21ba1853671ceaf7b3ac51292c7ecd755be5a458810becb1128b5e825b",
    "metadata": {},
    "name": "FolderOverviewFirstPageQuery",
    "operationKind": "query",
    "text": "query FolderOverviewFirstPageQuery($id:ID!,$after:String,$contentId:ID!,$includeDevDocsSyncStatus:Boolean=false,$includeAutomationDiscovery:Boolean=false){...FolderViewActions_query_3SK5LQ@include(if:$includeAutomationDiscovery),ptpage(id:$id,status:[CURRENT,DRAFT]){id,title,type,subType,children(first:40,after:$after){nodes{id,title,status,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage,endCursor}}},singleContent(id:$contentId){operations{operation},contentProperties{latest{coverPicture}},properties(keys:[\"smartFolderProperties\"]){nodes{id,key,value}},devDocsOwnershipProperties:properties(keys:[\"devdocsProperties\"]){nodes{id,key}},devDocsProperties:properties(keys:[\"devdocsProperties\"])@include(if:$includeDevDocsSyncStatus){nodes{id,key,value}},id}}fragment AutomationActionsMenu_query_3SK5LQ on Query{...useKeepUpToDateAction_query_3SK5LQ}fragment FolderViewActions_query_3SK5LQ on Query{...AutomationActionsMenu_query_3SK5LQ}fragment useKeepUpToDateAction_query_3SK5LQ on Query{user:confluence_atlassianUser(current:true){emails{value,isPrimary},id},singleContent(id:$contentId){ancestors{id},id}}"
  }
};
})();

(node as any).hash = "b97fbaecf10e487bb1c7d2dafddcfa29";

export default node;
